import React from 'react';
//import styles from '../styles/index.scss';

export interface IApplicationProps {
    children?: React.ReactNode;
}

export interface IApplicationState {

}

export class XApplication extends React.Component<IApplicationProps, IApplicationState> {
     public constructor(props: IApplicationProps) {
          super(props)
     }

     render(): React.ReactNode {
         return this.props.children;
     }
 }
